
<template>
  <div>
    <svg width="11" height="23" viewBox="0 0 11 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!isHovered">
      <path d="M10.2143 1.58621C9.78035 1.58621 9.42857 1.93798 9.42857 2.37192V3.63717L6.28571 6.80959V0.785715C6.28571 0.351777 5.93394 0 5.5 0C5.06606 0 4.71429 0.351776 4.71429 0.785715V6.80959L1.57143 3.63717V2.37192C1.57143 1.93798 1.21965 1.58621 0.785714 1.58621C0.351776 1.58621 0 1.93798 0 2.37192V14.2759C0.00220109 15.6096 0.479703 16.8979 1.34526 17.9056C2.21082 18.9133 3.40666 19.573 4.71429 19.7641V22.2143C4.71429 22.6482 5.06606 23 5.5 23C5.93394 23 6.28571 22.6482 6.28571 22.2143V19.7641C7.59334 19.573 8.78918 18.9133 9.65474 17.9056C10.5203 16.8979 10.9978 15.6096 11 14.2759V2.37192C11 1.93798 10.6482 1.58621 10.2143 1.58621ZM4.71429 18.1613C3.82774 17.9771 3.03116 17.4901 2.4587 16.7824C1.88625 16.0747 1.5729 15.1895 1.57143 14.2759V12.2249L4.71429 15.3973V18.1613ZM4.71429 13.1544L1.57143 9.982V5.88007L4.71429 9.05248V13.1544ZM6.28571 9.05248L9.42857 5.88007V9.982L6.28571 13.1544V9.05248ZM6.28571 18.1613V15.3973L9.42857 12.2249V14.2759C9.4271 15.1895 9.11375 16.0747 8.5413 16.7824C7.96884 17.4901 7.17226 17.9771 6.28571 18.1613Z" fill="black"/>
    </svg>
    <svg width="11" height="23" viewBox="0 0 11 23" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="isHovered">
    <path d="M10.2143 1.58621C9.78035 1.58621 9.42857 1.93798 9.42857 2.37192V3.63717L6.28571 6.80959V0.785715C6.28571 0.351777 5.93394 0 5.5 0C5.06606 0 4.71429 0.351776 4.71429 0.785715V6.80959L1.57143 3.63717V2.37192C1.57143 1.93798 1.21965 1.58621 0.785714 1.58621C0.351776 1.58621 0 1.93798 0 2.37192V14.2759C0.00220109 15.6096 0.479703 16.8979 1.34526 17.9056C2.21082 18.9133 3.40666 19.573 4.71429 19.7641V22.2143C4.71429 22.6482 5.06606 23 5.5 23C5.93394 23 6.28571 22.6482 6.28571 22.2143V19.7641C7.59334 19.573 8.78918 18.9133 9.65474 17.9056C10.5203 16.8979 10.9978 15.6096 11 14.2759V2.37192C11 1.93798 10.6482 1.58621 10.2143 1.58621ZM4.71429 18.1613C3.82774 17.9771 3.03116 17.4901 2.4587 16.7824C1.88625 16.0747 1.5729 15.1895 1.57143 14.2759V12.2249L4.71429 15.3973V18.1613ZM4.71429 13.1544L1.57143 9.982V5.88007L4.71429 9.05248V13.1544ZM6.28571 9.05248L9.42857 5.88007V9.982L6.28571 13.1544V9.05248ZM6.28571 18.1613V15.3973L9.42857 12.2249V14.2759C9.4271 15.1895 9.11375 16.0747 8.5413 16.7824C7.96884 17.4901 7.17226 17.9771 6.28571 18.1613Z" fill="#BB4ECE"/>
    </svg>
  </div>

</template>
    
<script>
export default {
  components: {
  },
  props: {
    isHovered: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 18px;
}  
</style>
    
    